import { render, staticRenderFns } from "./OrderSpreadsheetFormatsEdit.vue?vue&type=template&id=98b99dca&"
import script from "./OrderSpreadsheetFormatsEdit.vue?vue&type=script&lang=js&"
export * from "./OrderSpreadsheetFormatsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports